import { FormProvider } from "react-hook-form";
import { classNames } from "primereact/utils";
import { AppDialog } from "../../../../../common/components/AppDialog/AppDialog";
import { DefaultButton } from "../../../../../common/components/button/defaultButton/DefaultButton";
import { DefaultInputField } from "../../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { DepositTransactionMode } from "../models/userDepositTransactionFormModel";
import { useUserDepositTransactionDialog } from "../hooks/useUserDepositTransactionDialog";
import styles from "./UserDepositTransactionDialog.module.scss";

interface IUserDepositTransactionDialogProps {
  userId?: number;
  mode: DepositTransactionMode;
  visible: boolean;
  onHide: () => void;
}

export const UserDepositTransactionDialog = ({
  userId,
  mode,
  visible,
  onHide,
}: IUserDepositTransactionDialogProps) => {
  const { form, isLoading, headerLabel, confirmLabel, handleSubmit } =
    useUserDepositTransactionDialog({ userId, mode, visible, onHide });

  return (
    <AppDialog
      header={headerLabel}
      visible={visible}
      className={styles.dialog}
      onHide={onHide}
    >
      <FormProvider {...form}>
        {/* A real submit handler so Enter in either field submits the form. */}
        <form className={styles.form} onSubmit={handleSubmit}>
          <DefaultInputField
            name="amount"
            label="Сума"
            placeholder="0.00"
            type="number"
            min={0}
            step={0.01}
            required
            width="100%"
          />

          <DefaultInputField
            name="comment"
            label="Коментар"
            placeholder="Коментар (задължителен)"
            required
            width="100%"
          />

          <div className={styles.footer}>
            <DefaultButton
              label={confirmLabel}
              type="submit"
              className={classNames({
                [styles.confirm_topUp]: mode === "topUp",
                [styles.confirm_withdraw]: mode === "withdraw",
              })}
              loading={isLoading}
            />
          </div>
        </form>
      </FormProvider>
    </AppDialog>
  );
};
